
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CoreTechnologySection() {
  const { t } = useTranslation();
  const { isVisible, setElementRef } = useScrollAnimation();

  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/1c2154c3420716a17df51e751e03b497.png',
      title: 'ものづくりの原点への回帰',
      description:
        '2022年度、工業製品開発から「身につけるプロダクト」への探求心により、アパレル業界への新たな挑戦をスタートしました。'
    },
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/6dc6c3f0545f9454f5d6b264497ea57d.png',
      title: 'フルカラー3Dプリント技術の応用',
      description:
        'フルカラー3Dプリント技術をアパレル領域に応用し、アクセサリーやパーツデザインとして新たな表現手法を開拓しました。'
    },
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/98157499d89d77edf2fc62d784ab3040.png',
      title: 'ニットの無限の可能性',
      description:
        'ニットが持つ柔軟で立体的な表現力を発見し、この素材の持つ無限の可能性に新たな価値を見出しました。'
    },
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/a4419b8cba133c53d11c66ca8bed2f11.png',
      title: 'インダストリーニットの誕生',
      description:
        'ニットの表現力を工業用途へ転用することで、機能性と造形美を兼ね備えた新しいソリューション「インダストリーニット」が誕生しました。'
    },
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/a0244fde66e3f6c59d95b0d541532e63.png',
      title: '新しい"産業の布"',
      description:
        'アパレルで培った感性と工業デザインで磨かれた技術が融合した、まったく新しい"産業の布"の創造に成功しました。'
    }
  ];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(slideInterval);
  }, [slides.length]);

  return (
    <section id="core-tech" className="py-24 bg-stone-50" ref={setElementRef}>
      <div className="container mx-auto px-4">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          
          <p className="text-xl md:text-2xl font-thin text-center mb-16 text-stone-600 max-w-3xl mx-auto">
            Industrial Knit – Design Woven with Intelligence
          </p>

          <div className="relative max-w-6xl mx-auto">
            {/* スライドショーコンテナ */}
            <div className="relative h-[250px] sm:h-[350px] md:h-[450px] lg:h-[550px] xl:h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-all duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'}`}
                >
                  <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                      backgroundImage: `url('${slide.image}')`,
                      backgroundPosition: 'center center',
                      backgroundSize: 'cover'
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* 詳細情報セクション */}
          <div className="mt-16 text-center">
            <div className="max-w-4xl mx-auto text-center">
              <div className="bg-stone-100 rounded-2xl p-8 mb-8">
                <p className="text-stone-700 text-lg leading-relaxed">
                  {t('coreTech.companyDescription')}
                </p>
              </div>

              <a
                href="https://ritsu-h.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-3 bg-stone-800 text-white rounded-full hover:bg-stone-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                【ritsu】
                <i className="ri-external-link-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
